import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

// Icons from the Food Management Figma (Web Icons). Colors follow `currentColor`.
// "large" is drawn on a 24px grid, "small" on a 16px grid with a heavier stroke.
const LARGE_ICONS: Record<string, React.ReactNode> = {
  celery: (
    <>
      <path
        d="M10.3 9V18C10.3 19.6 11 20.5 12 20.5C13 20.5 13.7 19.6 13.7 18V9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 9.6V18.4" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12 9.2C10.2 7.6 9.6 5 10.5 3C11 4.2 11.5 4.2 12 3.2C12.5 4.2 13 4.2 13.5 3C14.4 5 13.8 7.6 12 9.2Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6 9.3C8 8.7 6.2 6.7 6.2 4.3C7.4 4.9 8 4.9 8.4 3.8C9.1 4.9 9.8 5.2 10.6 4.8C10.9 6.7 11.4 8.1 10.6 9.3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4 9.3C16 8.7 17.8 6.7 17.8 4.3C16.6 4.9 16 4.9 15.6 3.8C14.9 4.9 14.2 5.2 13.4 4.8C13.1 6.7 12.6 8.1 13.4 9.3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  crustaceans: (
    <>
      <path
        d="M11 7.4C10.0667 4.8 9.5 3 9.3 2M13 7.4C13.9333 4.8 14.5 3 14.7 2"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 7.3C6.27025 7.3 7.3 6.27025 7.3 5C7.3 3.72975 6.27025 2.7 5 2.7C3.72975 2.7 2.7 3.72975 2.7 5C2.7 6.27025 3.72975 7.3 5 7.3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.6 6.7C7.66667 8.1 8.63333 9.16667 9.5 9.9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M19 7.3C20.2703 7.3 21.3 6.27025 21.3 5C21.3 3.72975 20.2703 2.7 19 2.7C17.7297 2.7 16.7 3.72975 16.7 5C16.7 6.27025 17.7297 7.3 19 7.3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17.4 6.7C16.3333 8.1 15.3667 9.16667 14.5 9.9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9 10.4C9 7.6 10.3 6.2 12 6.2C13.7 6.2 15 7.6 15 10.4C15 13.4 13.8 16.3 12 17.5C10.2 16.3 9 13.4 9 10.4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8 10.85C11.1038 10.85 11.35 10.6038 11.35 10.3C11.35 9.99624 11.1038 9.75 10.8 9.75C10.4962 9.75 10.25 9.99624 10.25 10.3C10.25 10.6038 10.4962 10.85 10.8 10.85Z"
        fill="currentColor"
      />
      <path
        d="M13.2 10.85C13.5038 10.85 13.75 10.6038 13.75 10.3C13.75 9.99624 13.5038 9.75 13.2 9.75C12.8962 9.75 12.65 9.99624 12.65 10.3C12.65 10.6038 12.8962 10.85 13.2 10.85Z"
        fill="currentColor"
      />
      <path d="M9.1 11.8L6.3 12.9M9.4 13.8L7 15.3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.9 11.8L17.7 12.9M14.6 13.8L17 15.3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.8 17.4C10 19 10 20.5 9.2 22.2C9.73333 21.7333 10.2667 21.8 10.8 22.4C11.2 21.8 11.6 21.8333 12 22.5C12.4 21.8333 12.8 21.8 13.2 22.4C13.7333 21.8 14.2667 21.7333 14.8 22.2C14 20.5 14 19 13.2 17.4H10.8Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  eggs: (
    <>
      <path
        d="M12 4C8.5 4 6 8.2 6 12.5C6 17 8.5 20 12 20C15.5 20 18 17 18 12.5C18 8.2 15.5 4 12 4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.6C13.4359 15.6 14.6 14.4359 14.6 13C14.6 11.5641 13.4359 10.4 12 10.4C10.5641 10.4 9.4 11.5641 9.4 13C9.4 14.4359 10.5641 15.6 12 15.6Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  fish: (
    <>
      <path d="M3 12C5 9 8 7 12 7C15.5 7 18 8.6 19.5 11" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 12C5 15 8 17 12 17C15.5 17 18 15.4 19.5 13" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.5 8L22 6V18L19.5 16" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7.5 11.8C7.94183 11.8 8.3 11.4418 8.3 11C8.3 10.5582 7.94183 10.2 7.5 10.2C7.05817 10.2 6.7 10.5582 6.7 11C6.7 11.4418 7.05817 11.8 7.5 11.8Z"
        fill="currentColor"
      />
    </>
  ),
  gluten: (
    <>
      <path d="M12 21V9.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 9.5C9.8 9.5 8.4 8 8.4 5.8C10.6 5.8 12 7.3 12 9.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12 9.5C14.2 9.5 15.6 8 15.6 5.8C13.4 5.8 12 7.3 12 9.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14C9.8 14 8.4 12.5 8.4 10.3C10.6 10.3 12 11.8 12 14Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14C14.2 14 15.6 12.5 15.6 10.3C13.4 10.3 12 11.8 12 14Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18.5C9.8 18.5 8.4 17 8.4 14.8C10.6 14.8 12 16.3 12 18.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18.5C14.2 18.5 15.6 17 15.6 14.8C13.4 14.8 12 16.3 12 18.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  lupin: (
    <>
      <path d="M12 21V14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12 14C10 14 9 13 9 11.5C9 10 10 9 12 9C14 9 15 10 15 11.5C15 13 14 14 12 14Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9C10.3 9 9.5 8.2 9.5 7C9.5 5.8 10.5 5 12 5C13.5 5 14.5 5.8 14.5 7C14.5 8.2 13.7 9 12 9Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5C10.8 5 10 4.3 10 3.3C10 2.3 10.8 2 12 2C13.2 2 14 2.6 14 3.3C14 4 13.2 5 12 5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 18L7 19M15 18L17 19" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  milk: (
    <>
      <path
        d="M6 9H18V20.5C18 20.6326 17.9473 20.7598 17.8536 20.8536C17.7598 20.9473 17.6326 21 17.5 21H6.5C6.36739 21 6.24021 20.9473 6.14645 20.8536C6.05268 20.7598 6 20.6326 6 20.5V9Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 9L9 5.5H15L18 9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.5 5.5V4H14.5V5.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 9V21" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  molluscs: (
    <>
      <path
        d="M11 17.3L3.8 10.3C3.8 4.6 9 3.2 12 3.2C15 3.2 20.2 4.6 20.2 10.3L13 17.3H11Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 17V4.2M17 8.5L12 17L7 8.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.5 17.8H15.5V20.6H8.5V17.8Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  mustard: (
    <>
      <path
        d="M10 3H14V6L15.5 8V20C15.5 20.2652 15.3946 20.5196 15.2071 20.7071C15.0196 20.8946 14.7652 21 14.5 21H9.5C9.23478 21 8.98043 20.8946 8.79289 20.7071C8.60536 20.5196 8.5 20.2652 8.5 20V8L10 6V3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11 3V2H13V3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 12H15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  peanuts: (
    <>
      <path
        d="M12 3.8C9.7 3.8 8 5.3 8 7.3C8 8.5 8.6 9.4 9.2 10.3C9.7 11 9.7 12 9.2 12.7C8.6 13.6 8 14.5 8 15.7C8 17.7 9.7 19.2 12 19.2C14.3 19.2 16 17.7 16 15.7C16 14.5 15.4 13.6 14.8 12.7C14.3 12 14.3 11 14.8 10.3C15.4 9.4 16 8.5 16 7.3C16 5.3 14.3 3.8 12 3.8Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 4.8V19.2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 6C9.6 10 9.6 14 10 18" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 6C14.4 10 14.4 14 14 18" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  sesame: (
    <>
      <path
        d="M9.85238 17.9002C10.8535 17.4334 11.0595 15.7565 10.3126 14.1548C9.56572 12.553 8.1487 11.633 7.14762 12.0998C6.14654 12.5666 5.94049 14.2435 6.68738 15.8452C7.43428 17.447 8.8513 18.367 9.85238 17.9002Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1476 17.9002C15.1487 18.367 16.5657 17.447 17.3126 15.8452C18.0595 14.2435 17.8535 12.5666 16.8524 12.0998C15.8513 11.633 14.4343 12.553 13.6874 14.1548C12.9405 15.7565 13.1465 17.4334 14.1476 17.9002Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.2C13.1046 12.2 14 10.7673 14 9C14 7.23269 13.1046 5.8 12 5.8C10.8954 5.8 10 7.23269 10 9C10 10.7673 10.8954 12.2 12 12.2Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  soybeans: (
    <>
      <path
        d="M5 17C4 14 6 9 10 7C14 5 19 6 20 8C17 7 13 9 11 12C9 15 8 19 5 17Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15.3C9.71797 15.3 10.3 14.718 10.3 14C10.3 13.282 9.71797 12.7 9 12.7C8.28203 12.7 7.7 13.282 7.7 14C7.7 14.718 8.28203 15.3 9 15.3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.3C12.718 12.3 13.3 11.718 13.3 11C13.3 10.282 12.718 9.7 12 9.7C11.282 9.7 10.7 10.282 10.7 11C10.7 11.718 11.282 12.3 12 12.3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 10.3C15.718 10.3 16.3 9.71797 16.3 9C16.3 8.28203 15.718 7.7 15 7.7C14.282 7.7 13.7 8.28203 13.7 9C13.7 9.71797 14.282 10.3 15 10.3Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  sulphites: (
    <>
      <path
        d="M7 4H17L16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10L7 4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 14V20" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 20H15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  tree_nuts: (
    <>
      <path d="M12 4.5V7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.6 9.8C6.6 8.2 9 7 12 7C15 7 17.4 8.2 17.4 9.8C17.4 10.6 16.8 11.2 15.9 11.2H8.1C7.2 11.2 6.6 10.6 6.6 9.8Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11.2C6.8 12.4 6 14.2 6 16.2C6 19.4 8.7 22 12 22C15.3 22 18 19.4 18 16.2C18 14.2 17.2 12.4 16 11.2"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
};

const SMALL_ICONS: Record<string, React.ReactNode> = {
  celery: (
    <>
      <path
        d="M6.86667 6V12C6.86667 13.0667 7.33333 13.6667 8 13.6667C8.66667 13.6667 9.13333 13.0667 9.13333 12V6"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 6.4V12.2667" stroke="currentColor" strokeWidth="0.766667" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8 6.13333C6.8 5.06667 6.4 3.33333 7 2C7.33333 2.8 7.66667 2.8 8 2.13333C8.33333 2.8 8.66667 2.8 9 2C9.6 3.33333 9.2 5.06667 8 6.13333Z"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.06667 6.2C5.33333 5.8 4.13333 4.46667 4.13333 2.86667C4.93333 3.26667 5.33333 3.26667 5.6 2.53333C6.06667 3.26667 6.53333 3.46667 7.06667 3.2C7.26667 4.46667 7.6 5.4 7.06667 6.2Z"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.93333 6.2C10.6667 5.8 11.8667 4.46667 11.8667 2.86667C11.0667 3.26667 10.6667 3.26667 10.4 2.53333C9.93333 3.26667 9.46667 3.46667 8.93333 3.2C8.73333 4.46667 8.4 5.4 8.93333 6.2Z"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  crustaceans: (
    <>
      <path
        d="M7.33333 4.93333C6.71111 3.2 6.33333 2 6.2 1.33333M8.66667 4.93333C9.28889 3.2 9.66667 2 9.8 1.33333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 4.86667C4.18017 4.86667 4.86667 4.18017 4.86667 3.33333C4.86667 2.4865 4.18017 1.8 3.33333 1.8C2.4865 1.8 1.8 2.4865 1.8 3.33333C1.8 4.18017 2.4865 4.86667 3.33333 4.86667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.4 4.46667C5.11111 5.4 5.75556 6.11111 6.33333 6.6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.6667 4.86667C13.5135 4.86667 14.2 4.18017 14.2 3.33333C14.2 2.4865 13.5135 1.8 12.6667 1.8C11.8198 1.8 11.1333 2.4865 11.1333 3.33333C11.1333 4.18017 11.8198 4.86667 12.6667 4.86667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.6 4.46667C10.8889 5.4 10.2444 6.11111 9.66667 6.6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6 6.93333C6 5.06667 6.86667 4.13333 8 4.13333C9.13333 4.13333 10 5.06667 10 6.93333C10 8.93333 9.2 10.8667 8 11.6667C6.8 10.8667 6 8.93333 6 6.93333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.2 7.23333C7.4025 7.23333 7.56667 7.06917 7.56667 6.86667C7.56667 6.66416 7.4025 6.5 7.2 6.5C6.9975 6.5 6.83333 6.66416 6.83333 6.86667C6.83333 7.06917 6.9975 7.23333 7.2 7.23333Z"
        fill="currentColor"
      />
      <path
        d="M8.8 7.23333C9.0025 7.23333 9.16667 7.06917 9.16667 6.86667C9.16667 6.66416 9.0025 6.5 8.8 6.5C8.5975 6.5 8.43333 6.66416 8.43333 6.86667C8.43333 7.06917 8.5975 7.23333 8.8 7.23333Z"
        fill="currentColor"
      />
      <path d="M6.06667 7.86667L4.2 8.6M6.26667 9.2L4.66667 10.2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.93333 7.86667L11.8 8.6M9.73333 9.2L11.3333 10.2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7.2 11.6C6.66667 12.6667 6.66667 13.6667 6.13333 14.8C6.48889 14.4889 6.84444 14.5333 7.2 14.9333C7.46667 14.5333 7.73333 14.5556 8 15C8.26667 14.5556 8.53333 14.5333 8.8 14.9333C9.15556 14.5333 9.51111 14.4889 9.86667 14.8C9.33333 13.6667 9.33333 12.6667 8.8 11.6H7.2Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  eggs: (
    <>
      <path
        d="M8 2.66667C5.66667 2.66667 4 5.46667 4 8.33333C4 11.3333 5.66667 13.3333 8 13.3333C10.3333 13.3333 12 11.3333 12 8.33333C12 5.46667 10.3333 2.66667 8 2.66667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.4C8.95729 10.4 9.73333 9.62396 9.73333 8.66667C9.73333 7.70937 8.95729 6.93333 8 6.93333C7.04271 6.93333 6.26667 7.70937 6.26667 8.66667C6.26667 9.62396 7.04271 10.4 8 10.4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  fish: (
    <>
      <path
        d="M2 8C3.33333 6 5.33333 4.66667 8 4.66667C10.3333 4.66667 12 5.73333 13 7.33333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8C3.33333 10 5.33333 11.3333 8 11.3333C10.3333 11.3333 12 10.2667 13 8.66667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13 5.33333L14.6667 4V12L13 10.6667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M5 7.86667C5.29455 7.86667 5.53333 7.62789 5.53333 7.33333C5.53333 7.03878 5.29455 6.8 5 6.8C4.70545 6.8 4.46667 7.03878 4.46667 7.33333C4.46667 7.62789 4.70545 7.86667 5 7.86667Z"
        fill="currentColor"
      />
    </>
  ),
  gluten: (
    <>
      <path d="M8 14V6.33333" stroke="currentColor" strokeWidth="0.766667" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8 6.33333C6.53333 6.33333 5.6 5.33333 5.6 3.86667C7.06667 3.86667 8 4.86667 8 6.33333Z"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6.33333C9.46667 6.33333 10.4 5.33333 10.4 3.86667C8.93333 3.86667 8 4.86667 8 6.33333Z"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.33333C6.53333 9.33333 5.6 8.33333 5.6 6.86667C7.06667 6.86667 8 7.86667 8 9.33333Z"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.33333C9.46667 9.33333 10.4 8.33333 10.4 6.86667C8.93333 6.86667 8 7.86667 8 9.33333Z"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.3333C6.53333 12.3333 5.6 11.3333 5.6 9.86667C7.06667 9.86667 8 10.8667 8 12.3333Z"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.3333C9.46667 12.3333 10.4 11.3333 10.4 9.86667C8.93333 9.86667 8 10.8667 8 12.3333Z"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  lupin: (
    <>
      <path d="M8 14V9.33333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8 9.33333C6.66667 9.33333 6 8.66667 6 7.66667C6 6.66667 6.66667 6 8 6C9.33333 6 10 6.66667 10 7.66667C10 8.66667 9.33333 9.33333 8 9.33333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6C6.86667 6 6.33333 5.46667 6.33333 4.66667C6.33333 3.86667 7 3.33333 8 3.33333C9 3.33333 9.66667 3.86667 9.66667 4.66667C9.66667 5.46667 9.13333 6 8 6Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 3.33333C7.2 3.33333 6.66667 2.86667 6.66667 2.2C6.66667 1.53333 7.2 1.33333 8 1.33333C8.8 1.33333 9.33333 1.73333 9.33333 2.2C9.33333 2.66667 8.8 3.33333 8 3.33333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 12L4.66667 12.6667M10 12L11.3333 12.6667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  milk: (
    <>
      <path
        d="M4 6H12V13.6667C12 13.7551 11.9649 13.8399 11.9024 13.9024C11.8399 13.9649 11.7551 14 11.6667 14H4.33333C4.24493 14 4.16014 13.9649 4.09763 13.9024C4.03512 13.8399 4 13.7551 4 13.6667V6Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4 6L6 3.66667H10L12 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.33333 3.66667V2.66667H9.66667V3.66667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.33333 6V14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  molluscs: (
    <>
      <path
        d="M7.33333 11.5333L2.53333 6.86667C2.53333 3.06667 6 2.13333 8 2.13333C10 2.13333 13.4667 3.06667 13.4667 6.86667L8.66667 11.5333H7.33333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11.3333V2.8M11.3333 5.66667L8 11.3333L4.66667 5.66667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.66667 11.8667H10.3333V13.7333H5.66667V11.8667Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  mustard: (
    <>
      <path
        d="M6.66667 2H9.33333V4L10.3333 5.33333V13.3333C10.3333 13.5101 10.2631 13.6797 10.1381 13.8047C10.013 13.9298 9.84348 14 9.66667 14H6.33333C6.15652 14 5.98695 13.9298 5.86193 13.8047C5.7369 13.6797 5.66667 13.5101 5.66667 13.3333V5.33333L6.66667 4V2Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.33333 2V1.33333H8.66667V2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 8H10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  peanuts: (
    <>
      <path
        d="M8 2.53333C6.46667 2.53333 5.33333 3.53333 5.33333 4.86667C5.33333 5.66667 5.73333 6.26667 6.13333 6.86667C6.46667 7.33333 6.46667 8 6.13333 8.46667C5.73333 9.06667 5.33333 9.66667 5.33333 10.4667C5.33333 11.8 6.46667 12.8 8 12.8C9.53333 12.8 10.6667 11.8 10.6667 10.4667C10.6667 9.66667 10.2667 9.06667 9.86667 8.46667C9.53333 8 9.53333 7.33333 9.86667 6.86667C10.2667 6.26667 10.6667 5.66667 10.6667 4.86667C10.6667 3.53333 9.53333 2.53333 8 2.53333Z"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 3.2V12.8" stroke="currentColor" strokeWidth="0.766667" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.66667 4C6.4 6.66667 6.4 9.33333 6.66667 12"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33333 4C9.6 6.66667 9.6 9.33333 9.33333 12"
        stroke="currentColor"
        strokeWidth="0.766667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  sesame: (
    <>
      <path
        d="M6.56825 11.9335C7.23564 11.6222 7.37301 10.5043 6.87508 9.43651C6.37715 8.36869 5.43247 7.75534 4.76508 8.06654C4.09769 8.37775 3.96032 9.49567 4.45826 10.5635C4.95619 11.6313 5.90087 12.2447 6.56825 11.9335Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.43175 11.9335C10.0991 12.2447 11.0438 11.6313 11.5417 10.5635C12.0397 9.49567 11.9023 8.37775 11.2349 8.06654C10.5675 7.75534 9.62285 8.36869 9.12492 9.43651C8.62699 10.5043 8.76436 11.6222 9.43175 11.9335Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8.13333C8.73638 8.13333 9.33333 7.17821 9.33333 6C9.33333 4.82179 8.73638 3.86667 8 3.86667C7.26362 3.86667 6.66667 4.82179 6.66667 6C6.66667 7.17821 7.26362 8.13333 8 8.13333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  soybeans: (
    <>
      <path
        d="M3.33333 11.3333C2.66667 9.33333 4 6 6.66667 4.66667C9.33333 3.33333 12.6667 4 13.3333 5.33333C11.3333 4.66667 8.66667 6 7.33333 8C6 10 5.33333 12.6667 3.33333 11.3333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10.2C6.47865 10.2 6.86667 9.81198 6.86667 9.33333C6.86667 8.85469 6.47865 8.46667 6 8.46667C5.52135 8.46667 5.13333 8.85469 5.13333 9.33333C5.13333 9.81198 5.52135 10.2 6 10.2Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8.2C8.47865 8.2 8.86667 7.81198 8.86667 7.33333C8.86667 6.85469 8.47865 6.46667 8 6.46667C7.52135 6.46667 7.13333 6.85469 7.13333 7.33333C7.13333 7.81198 7.52135 8.2 8 8.2Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.86667C10.4786 6.86667 10.8667 6.47865 10.8667 6C10.8667 5.52135 10.4786 5.13333 10 5.13333C9.52135 5.13333 9.13333 5.52135 9.13333 6C9.13333 6.47865 9.52135 6.86667 10 6.86667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  sulphites: (
    <>
      <path
        d="M4.66667 2.66667H11.3333L10.6667 6.66667C10.6667 7.37391 10.3857 8.05219 9.88562 8.55228C9.38552 9.05238 8.70724 9.33333 8 9.33333C7.29276 9.33333 6.61448 9.05238 6.11438 8.55228C5.61428 8.05219 5.33333 7.37391 5.33333 6.66667L4.66667 2.66667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 9.33333V13.3333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 13.3333H10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  tree_nuts: (
    <>
      <path d="M8 3V4.66667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M4.4 6.53333C4.4 5.46667 6 4.66667 8 4.66667C10 4.66667 11.6 5.46667 11.6 6.53333C11.6 7.06667 11.2 7.46667 10.6 7.46667H5.4C4.8 7.46667 4.4 7.06667 4.4 6.53333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33333 7.46667C4.53333 8.26667 4 9.46667 4 10.8C4 12.9333 5.8 14.6667 8 14.6667C10.2 14.6667 12 12.9333 12 10.8C12 9.46667 11.4667 8.26667 10.6667 7.46667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
};

interface AllergenIconProps extends SvgIconProps {
  allergenKey: string;
  size?: "small" | "large";
}

export const AllergenIcon = ({ allergenKey, size = "large", sx, ...props }: AllergenIconProps) => {
  const icon = (size === "small" ? SMALL_ICONS : LARGE_ICONS)[allergenKey];
  if (!icon) return null;

  return (
    <SvgIcon viewBox={size === "small" ? "0 0 16 16" : "0 0 24 24"} sx={[{ fill: "none" }, ...(Array.isArray(sx) ? sx : [sx])]} {...props}>
      {icon}
    </SvgIcon>
  );
};
